import type { EngageDomainRecords } from '@/store/features/engage.feature';

/**
 * What is wrong with a sending domain's records, SPF first. A record the DNS
 * read timed out on is "not read", not missing. A free mail domain has no
 * records (all null) and nothing to fix.
 */
export function domainProblems(
  domain: Pick<EngageDomainRecords, 'spf' | 'dkim' | 'dmarc'>
): string[] {
  const problems: string[] = [];
  if (domain.spf === 'missing') problems.push('SPF missing');
  else if (domain.spf === 'no_provider') problems.push('SPF incomplete');
  else if (domain.spf === 'unknown') problems.push('SPF not read');
  if (domain.dmarc === 'missing') problems.push('DMARC missing');
  else if (domain.dmarc === 'unknown') problems.push('DMARC not read');
  if (domain.dkim === 'unknown') problems.push('DKIM not found');
  return problems;
}

/** The part of an address after the @, lowercased. */
export function domainOf(email: string): string {
  return email.split('@').at(-1)?.trim().toLowerCase() ?? '';
}
